import { NgModule } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { FieldsetModule } from 'primeng/fieldset';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PasswordModule } from 'primeng/password';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  imports: [
    ButtonModule,
    DropdownModule,
    ToastModule,
    ProgressSpinnerModule,
    DynamicDialogModule,
    InputTextModule,
    InputTextareaModule,
    CheckboxModule,
    OverlayPanelModule,
    DividerModule,
    PasswordModule,
    FieldsetModule,
    SelectButtonModule,
    TooltipModule,
  ],
  exports: [
    ButtonModule,
    DropdownModule,
    ToastModule,
    ProgressSpinnerModule,
    DynamicDialogModule,
    InputTextModule,
    InputTextareaModule,
    CheckboxModule,
    OverlayPanelModule,
    DividerModule,
    PasswordModule,
    FieldsetModule,
    SelectButtonModule,
    TooltipModule,
  ],
  providers: [DialogService, MessageService],
})
export class PrimeNgModule {}
